export default "__VITE_ASSET__B9qG$pDX__"